var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBadge)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[
      'badge',
      ("badge-" + _vm.variant),
      {
        'badge-shape--rounded': _vm.rounded && (_vm.iconPosition || _vm.labelLength >= 3),
        'badge-shape--circle': _vm.rounded && !_vm.iconPosition && _vm.labelLength < 3,
        'badge-sm': _vm.size === 'slim'
      }
    ]},[_c('div',{staticClass:"d-flex"},[(_vm.iconPosition === 'left')?_c('m-icon',_vm._g({attrs:{"variant":_vm.iconVariant,"size":"small"}},_vm.$listeners)):_vm._e(),_c('span',{ref:"badgeLabel",class:[{
          'badge-font--rounded': _vm.rounded && (_vm.iconPosition || _vm.labelLength >= 3),
          'badge-font--circle': _vm.rounded && !_vm.iconPosition && _vm.labelLength < 3,
        }]},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2),(_vm.iconPosition === 'right')?_c('m-icon',_vm._g({attrs:{"variant":_vm.iconVariant,"size":"small"}},_vm.$listeners)):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }